import { AdUnit } from "../AdUnit/AdUnit"

export enum AdInteractionType {
  View = "view",
  Click = "click"
}

export interface AdInteraction {
  ad_unit?: AdUnit
  type: AdInteractionType
}
